import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { ContentWidth } from '@ta-interaktiv/react-disco-grid'
import FilterComponent from '../FilterComponent'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ContentWidth>
        {properties?.textBlocks && (
          <FilterComponent
            textBlocks={
              typeof properties.textBlocks === 'string'
                ? JSON.parse(properties.textBlocks)
                : properties.textBlocks
            }
            labelsKiToggle={
              typeof properties.labelsKiToggle === 'string'
                ? JSON.parse(properties.labelsKiToggle)
                : properties.labelsKiToggle
            }
            titleTextSection={properties?.titleTextSection}
            titleStyleSection={properties?.titleStyleSection}
            titleToggleSection={properties?.titleToggleSection}

            colorMode={colorMode}
          />
        )}
      </ContentWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  @media only screen and (max-width: 712px) {
  padding: 0 2rem;
  }
`

export default MainComponent
